import { Method } from '../../packages/neb-api-client/src/utils/api-client-utils';
import ApiClientV2 from '../../packages/neb-api-client/src/utils/api-client-v2';

export const apiClient = new ApiClientV2({ microservice: 'core' });
export const NOTIFICATIONS_REFRESH_INTERVAL = 300000;

export const getNotificationsCount = async ({
  userId,
  status,
  optOutLoadingIndicator = true,
}) => {
  const { total } = await apiClient.makeRequest({
    method: Method.GET,
    path: '/api/v1/tenants/:tenantId/notifications/:userId/:status/count',
    replacements: {
      userId,
      status,
    },
    optOutLoadingIndicator,
  });

  return total;
};

export const getNotifications = async ({
  userId,
  status = 'unread',
  limit = 10,
  offset = 0,
  optOutLoadingIndicator = true,
}) => {
  const { count, data } = await apiClient.makeRequest({
    method: Method.GET,
    path: '/api/v1/tenants/:tenantId/notifications/:userId',
    replacements: {
      userId,
    },
    queryParams: {
      status,
      limit,
      offset,
    },
    optOutLoadingIndicator,
  });

  return { count, data };
};

export const updateNotificationStatus = ({
  notificationUserIds,
  status,
  markAllAsRead = false,
  globalNotificationStatusChanges = false,
  optOutLoadingIndicator = true,
}) => {
  const body = { status };

  if (markAllAsRead) {
    body.markAllAsRead = true;
  } else {
    body.notificationUserIds = notificationUserIds;
  }

  if (globalNotificationStatusChanges) {
    body.globalNotificationStatusChanges = true;
  }

  return apiClient.makeRequest({
    method: Method.PUT,
    path: '/api/v1/tenants/:tenantId/notifications',
    body,
    optOutLoadingIndicator,
  });
};
